import { OK_VITALS_THRESHOLD, useVitalCardParams } from '../../../hooks/useVitalCardParams';
import type { AIToolComponent } from '../../chat-messages/GuardianMarkdown';
import { MetricCard } from '../shared/MetricCard';

export type VitalCardProps = {
  name: string;
  history: number[];
};

/**
 * The vitals reading of a `MetricCard`: this component owns the vitals policy — the score is the
 * last sample, and it is critical below {@link OK_VITALS_THRESHOLD} — and nothing else. The card
 * itself knows about neither.
 */
export const VitalCard: AIToolComponent<VitalCardProps> = ({ params: { name, history } }) => {
  const {
    // (hidden: serie, startingTimeStamp, sampleDuration, sampleInterval — for the sparkline)
    lastValue,
  } = useVitalCardParams(history);

  return (
    <MetricCard
      title={name}
      value={lastValue}
      status={lastValue < OK_VITALS_THRESHOLD ? 'critical' : 'headline'}
      /* Hidden sparkline for now, to be improved later
      footer={
        <Sparkline
          serie={serie}
          startingTimeStamp={startingTimeStamp}
          sampleDuration={sampleDuration}
          sampleInterval={sampleInterval}
          yAxisType="percentage"
        />
      } */
    />
  );
};

VitalCard.description = 'Displays a single vital with its history.';

VitalCard.schema = {
  type: 'object',
  properties: {
    name: { type: 'string' },
    history: { type: 'array', items: { type: 'number', minimum: 0, maximum: 100 }, minItems: 1, maxItems: 100 },
  },
  required: ['name', 'history'],
};

VitalCard.displayInPanel = true;
